import { wrapLinksInText } from '@/helpers/textHelpers.js';

/**
 * Mutates each post in the given array in place, wrapping URLs found in its
 * `text` (and, if present, its `repostedPost.text`) in clickable link markup.
 * @param {Array<Object>} posts posts to process
 * @returns {Array<Object>} the same array, with post text link-wrapped
 */
const processPostsArray = (posts) => {
  return posts.map(post => {
    if (post?.text) {
      post.text = wrapLinksInText(post.text);
    }
    if (post.repostedPost && post.repostedPost.text) {
      post.repostedPost.text = wrapLinksInText(post.repostedPost.text)
    }
    return post;
  });
};

/**
 * Vuex plugin that subscribes to every mutation and, whenever a mutation's
 * payload is (or contains, under `.data`) an array of posts, link-wraps the
 * text of those posts before they're rendered.
 * @param {import('vuex').Store} store the Vuex store to subscribe to
 */
const linkWrappingPlugin = (store) => {
  store.subscribe((mutation) => {
    if (!mutation.payload) return;

    let postsToProcess = mutation.payload.data || mutation.payload;

    if (Array.isArray(postsToProcess)) {
      processPostsArray(postsToProcess);
    }
  });
};

export default linkWrappingPlugin;
